import img from '../../../../../assets/images/textEditorToolBarIcons/Link.svg';

export const LinkButton = img;
